import { Button, Card, Loader, Stack, Text } from "@mantine/core";
import { Link } from "@tanstack/react-router";

import { useSession } from "@/hooks/@custom/useSession";
import { useGetQueueByCompanyQuery } from "@/store/apis/nextcargo";

type QueueActionsProps = unknown;

export function QueueActions(_props: QueueActionsProps) {
  const { driver } = useSession();
  const driverId = driver?.id;
  const driverCompanyId = driver?.company.id;

  const { data, isLoading } = useGetQueueByCompanyQuery({ id: driverCompanyId! }, { skip: !driverCompanyId });

  const queueIndex = data?.original.findIndex((item) => item.driver.id === driverId);
  const status = queueIndex! > -1;

  return (
    <Card className="border-gray-200! bg-gray-50!" withBorder>
      <Stack align="center" justify="center" gap="xs">
        {isLoading && (
          <div className="grid place-content-center">
            <Loader />
          </div>
        )}

        {!isLoading && (
          <>
            {!status && (
              <Button component={Link} to="/app/agendamento" fullWidth>
                Entrar na Fila
              </Button>
            )}

            {status && (
              <>
                <Text fw="bold" ta="center">
                  Você já possui um agendamento na fila!
                </Text>

                <Button component={Link} to="/app/agendamento/status" color="green" fullWidth>
                  Ir para minha posição
                </Button>
              </>
            )}
          </>
        )}
      </Stack>
    </Card>
  );
}
